import { useRouter } from 'next/router';
import { useContext, useEffect, useState } from 'react';
import { GlobalsContext } from '../../../../components/Context/globalsContext';
import { RequestNextApi } from '../../../../api/Request';
import { ProgressContext } from '../../../../components/Context/progressContext';
import LargeFirmHome from './home';
import { ShowNotification } from '../../../../utils/notification/snackbarUtils';
import MarketingNavigation from '../../../../navigation/marketing';
import { Button, TextField, Typography } from '@mui/material';

export default function LargeFirmLogin() {
    const router = useRouter();

    const { update: updateGlobals, state: globalsContext } = useContext(GlobalsContext);
    const { state: progressContext, update: updateProgress } = useContext(ProgressContext);

    const [title, setTitle] = useState('');
    const [password, setPassword] = useState('');

    const { pid } = router.query;
    useEffect(() => {
        if (pid) {
            var title = '';
            title = pid.replace(/-/g, ' ').toUpperCase();
            setTitle(title);
        }
    }, [pid]);

    const checkPassword = async (e) => {
        e.preventDefault();
        if (password) {
            updateProgress({ isLoading: true });
            await fetchFirms();
            updateProgress({ isLoading: false });
        }
    };

    const fetchFirms = async () => {
        try {
            const res = await RequestNextApi.post('/large-firms', {
                slug: pid,
                password: password,
            });
            if (res.data.success) {
                updateGlobals({ globals: res.data, isLogin: true });
            } else {
                ShowNotification.error(res.data.message);
            }
        } catch (error) {
            ShowNotification.error('Login Failed');
        }
    };

    return (
        <>
            {globalsContext?.isLogin ? (
                <LargeFirmHome></LargeFirmHome>
            ) : (
                <MarketingNavigation>
                    <div>
                        <div className='bg-primary-500 h-[300px] flex items-center'>
                            <div className='ml-16 p-4'>
                                <Typography variant='h1' className='text-white'>
                                    {title}
                                </Typography>
                            </div>
                        </div>
                        <div className='max-w-full px-4 w-[700px] mt-16 mx-auto text-center'>
                            <form
                                className='space-y-4'
                                onSubmit={(e) => {
                                    checkPassword(e);
                                }}
                            >
                                <Typography variant='h2'>This advisor site requires a password</Typography>
                                <TextField fullWidth label='Password' placeholder='Password' type='password' onChange={(e) => setPassword(e.target.value)} value={password} />
                                <Button variant='contained' color='secondary' type='submit' className='block w-full' size='large'>
                                    Login
                                </Button>
                            </form>
                        </div>
                    </div>
                </MarketingNavigation>
            )}
        </>
    );
}
